import React, { Fragment, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { url, postPerPage } from '../../../../config';
import { FormattedMessage, useIntl } from 'react-intl';
import { IMAGES } from '../../../../constants';
import { getLastURL, handleSortBy, pColmDisplay, handleSortByAction, numberWithCommas, numberWithDots, formatMmRangeValues } from '../../../../helper';
import { useDispatch, useSelector } from 'react-redux';
import { myProductAction, myProductFilterByAscending, myProductFilter, myProductSelectAction, myProductActiveAll, myProductShowSold , myProductDeleteAll, myProductDeactiveAll} from '../../../../actions/productActions';
import { parcelJson, selectActionJson } from '../../../../utils/json';
import $ from 'jquery';
import { getCategory } from '../../../../actions/categoryAction';
import { useAlert } from 'react-alert';
import ReactPaginate from "react-paginate";
import PopupConfirm from '../../../layout/PopupConfirm';

const Parcels = (props) => {

    const dispatch = useDispatch();
    const location = useLocation();
    const category_slug = getLastURL(location);
    const alert = useAlert();

    const { myproduct, loading } = useSelector(state => state.myproduct);
    const { myproductselectaction } = useSelector(state => state.myproductselectaction);
    const { myproductactiveall } = useSelector(state => state.myproductactiveall);

    const PARCEL_DEFAULT_SORT = { order_by_value: 'updated_at', order_by_type: 'desc' };

    const getParcelSortLabel = () => {
        const match = parcelJson.find(
            (item) => item.value === PARCEL_DEFAULT_SORT.order_by_value && item.type === PARCEL_DEFAULT_SORT.order_by_type
        );
        return match?.display_name || <FormattedMessage id="Newest to Oldest" defaultMessage="Newest to Oldest" />;
    };

    const ensureParcelDefaultSort = () => {
        const sortKey = category_slug + '_sortingmy';
        try {
            const stored = JSON.parse(localStorage.getItem(sortKey) || 'null');
            const legacyPriceAsc = stored?.order_by_value === 'price' && stored?.order_by_type === 'asc';
            if (!stored || stored.order_by_value === 'id' || legacyPriceAsc) {
                localStorage.setItem(sortKey, JSON.stringify(PARCEL_DEFAULT_SORT));
            }
        } catch {
            localStorage.setItem(sortKey, JSON.stringify(PARCEL_DEFAULT_SORT));
        }
    };

    const [filterdisplayname, setFilterDisplayName] = useState(getParcelSortLabel());
    const [actionname, setActionName] = useState(<FormattedMessage id="Actions"/>)
    const [search, setSearch] = useState();
    const [postsPerPage, setPostPerPage] = useState(postPerPage);
    const [selectAllStock, setSelectAllStock] = useState([]);
    const [selectedAction, setSeletedAction] = useState();
    const [selectedId, setSelectedId] = useState([]);
    const selectedArray = [];
    const [checkHead, setCheckHead] = useState(false);
    const [sold, setSold] = useState(false);
    const [selectFancy, setSelectFancy] = useState(false);

    const getStoredFilter = () => {
        try {
            return JSON.parse(localStorage.getItem(category_slug + "filter") || "{}");
        } catch {
            return {};
        }
    };

    const applyParcelFilter = (patch) => {
        const filter = { is_fancy: false, ...getStoredFilter(), ...patch };
        localStorage.setItem(category_slug + "filter", JSON.stringify(filter));
        dispatch(myProductFilter(category_slug, filter));
    };

    useEffect(() => {
        ensureParcelDefaultSort();
        setFilterDisplayName(getParcelSortLabel());
        setSelectFancy(false);
        const stored = getStoredFilter();
        const { is_fancy: _ignoredFancy, ...storedWithoutFancy } = stored;
        applyParcelFilter({ ...storedWithoutFancy, is_fancy: false });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, category_slug]);

    const handleSelectFancy = (e) => {
        const checked = e.target.checked;
        setSelectFancy(checked);
        props.tabChangeHandler(1);
        props.updateResetPageHandler(0);
        setSelectAllStock([]);
        setSelectedId([]);
        setCheckHead(false);
        applyParcelFilter({ is_fancy: checked });
    };

    const handlePageChange = ({ selected }) => {
        props.updateResetPageHandler(selected)
        dispatch(myProductAction(category_slug, (selected + 1)));
    }

    const pageCount = Math.ceil((myproduct && myproduct.products && myproduct.products.total) / postsPerPage);

    const handleAcendingFilter = (value, type, displayname) => {
        setFilterDisplayName(displayname)
        $('.sort_by_list').css({
            display: "none"
        })
        props.tabChangeHandler(1)
        dispatch(myProductFilterByAscending(category_slug, value, type))
    }

    const handleSearch = (e) => {
        setSearch(e.target.value);
    }

    const handleSearchFilter = (e) => {
        if (e.key === 'Enter') {
            applyParcelFilter({ search: search });
        }
    }

    const handleSearchIconClick = () => {
        applyParcelFilter({ search: search });
    };


    const handleStockManagement = (id, position) => {
        const updatedSelectAllStock = selectAllStock && selectAllStock.map((item, index) => {
            if (index === position) {
                return !item;
            } else {
                return item;
            }
        });
        setSelectAllStock(updatedSelectAllStock);

        if (!selectedId.includes(id)) {
            setSelectedId([...selectedId, id]);
        } else {
            selectedId.splice(selectedId.indexOf(id), 1);
        }
    }

    const selectAll = (selectAllStock) => {

        if (selectAllStock.every(e => e === false)) {
            setSelectAllStock(new Array(myproduct && myproduct.products && myproduct.products.data && myproduct.products.data.length).fill(true));

            myproduct && myproduct.products && myproduct.products.data && myproduct.products.data.map((data, key) => {
                selectedArray.push(data.id);
            })
            setCheckHead(true);
            setSelectedId(selectedArray);

        } else {
            setSelectAllStock(new Array(myproduct && myproduct.products && myproduct.products.data && myproduct.products.data.length).fill(false));
            selectedArray.pop();
            setSelectedId([]);
            setCheckHead(false);
        }

    }

    const handleSelectAction = (event, value) => {

        $('.sort_by_action').css({
            display: "none"
        })

        if (selectedId.every(e => e === false) || selectedId === null) {
            alert.error('Please select stock');
            setSeletedAction("");
            return;
        }
        setSeletedAction(value);
        dispatch(myProductSelectAction(selectedId, value));
        setSold(false);
    }

    // const handleActiveAll = () => {
    //     dispatch(myProductActiveAll());
    //     dispatch(myProductAction(category_slug));
    // }
    const handleActiveAll = async () => {
        await dispatch(myProductActiveAll());
        dispatch(myProductAction(category_slug));
      
    }
    const handleInActiveAll = async () => {
        await dispatch(myProductDeactiveAll(category_slug));
        dispatch(myProductAction(category_slug));
      
    }

    const handleResForm = (status) => {
        if(status){
            dispatch(myProductDeleteAll(category_slug));
            dispatch(myProductAction(category_slug));
            dispatch(getCategory());
        }
        $("#dismiss-modal").trigger('click');
  
    }
    const handleDeleteAllClick = (event) => {
        $("#popup-click-confirm").trigger('click');
    }
    useEffect(() => {
        if (myproductselectaction) {
            alert.success(myproductselectaction);
            setSelectAllStock([]);
            setSelectedId([]);
            setCheckHead(false);
            setSeletedAction("");
            dispatch(myProductAction(category_slug));
            dispatch(getCategory());
            return
        }
        if (myproductactiveall) {
            alert.success(myproductactiveall);
            return
        }
    }, [myproductselectaction, myproductactiveall])


    const handleSoldProducts = (event) => {
        setSold(event.target.checked);
        dispatch(myProductShowSold(category_slug, event.target.checked));
    }

    const handleSingleActivate = (action, id) => {
        let ids = [];
        ids.push(id)
        dispatch(myProductSelectAction(ids, action));
        dispatch(myProductAction(category_slug));
        dispatch(getCategory());
    }


    const handleDetails = (id) => {
        // history.push(url + `/details/parcels/${id}`);
       window.open(`${url}/details/parcels/${id}`, '_blank');
    
    }

    const isFancyList = myproduct && myproduct.is_fancy == 1;
    const parcelTableColSpan = isFancyList ? 17 : 15;

    const renderParcelMeasurements = (data) => {
        if (data?.mm_l != null && data?.mm_w != null && data?.mm_h != null) {
            return `${parseFloat(data.mm_l).toFixed(2)}x${parseFloat(data.mm_w).toFixed(2)}x${parseFloat(data.mm_h).toFixed(2)}`;
        }
        return data?.measurements || '';
    };

    const renderParcelTotalCt = (data) => {
        if (data?.carat == null || data?.pieces == null) return '';
        return numberWithDots((parseFloat(data.carat) * parseFloat(data.pieces)).toFixed(2));
    };

    const renderParcelTotalPrice = (data) => {
        if (data?.price == null || data?.carat == null || data?.pieces == null) return '';
        return numberWithCommas((parseFloat(data.price) * parseFloat(data.carat) * parseFloat(data.pieces)).toFixed(2));
    };


    return (
        <Fragment>
            {/* {loading && <Loader />} */}
            <Fragment>
                <div className="col-xl-10 col-lg-9 col-md-9 col-sm-8">
                {loading ? <div className="loader-line"></div> : ""}
                    <div className="titles mt-4 mb-3 pb-3">
                        <div className="row">
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <h2 className="m-0"><FormattedMessage id="category.parcels"  /> <span className="pro_nub">{myproduct && myproduct?.products && myproduct?.products?.total}</span></h2>
                            </div>
                            <div className="col-xl-9 col-lg-8 col-sm-6 col-md-6 hides ">
                                <div className=" form-group ml-3 form-inline">
                                    <button type="button" className="btn-black active-all" onClick={handleActiveAll}><span className="fa fa-check"></span><span>{` `}</span> <FormattedMessage id="UpdateMyListings" defaultMessage="Update My Listings"/></button>
                                </div>
                                <div className=" form-group ml-3 form-inline">
                                    <button type="button" className="btn-black active-all" onClick={handleInActiveAll}><span><span className="fa fa-close"></span><span>{` `}</span> <FormattedMessage id="UnlistAllItems" defaultMessage="Unlist All Items"/></span></button>
                                </div>    
                                <div className=" form-group ml-3 form-inline">
                                    <button type="button" className="btn-black active-all" onClick={handleDeleteAllClick}><span><span className="fa fa-trash"></span><span>{` `}</span> <FormattedMessage id="DeleteAllItems" defaultMessage="Delete All Items"/></span></button>
                                </div>
                                <div className="form-group mb-0 form-inline">
                                    <Link to={url + '/add-product'}><button type="button" className="btn-black"><span className="icon-add_1"></span><span>{` `}</span>
                                        <FormattedMessage
                                            id="addsingleproduct.add-new-product"
                                            defaultMessage="Add New Product"
                                        />
                                    </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="titles mt-4 border-0">
                        <div className="filter_search_right">
                            <div className="search_cat_top border-0">
                                <div className="row">

                                    <div className="col-lg-12 col-md-12 col-sm-12 d-flex flex-wrap justify-content-md-end">
                                        <div className="form-group mb-0 mr-3 form-inline ">
                                            <input type="checkbox" id="sold" checked={sold} onChange={handleSoldProducts} />
                                            <label htmlFor="sold" className="mt-2"><FormattedMessage id="Show sold products"  /></label>
                                        </div>
                                        <div className="form-group pb-0 sort_by_box">
                                            <p className="sort_b_h text-right side-dropdown" onClick={handleSortBy}><b className="mr-2"><FormattedMessage id="Sort_By"  />:</b>{filterdisplayname} <span
                                                className="icon-chevron_down"></span></p>
                                            <div className="sort_by_list">
                                                <ul>
                                                    {
                                                        parcelJson && parcelJson.map((data, key) => {
                                                            return (
                                                                <li className="activess" onClick={() => handleAcendingFilter(data.value, data.type, data.display_name)}>{data.display_name}</li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="row filter_search_right align-items-center justify-content-between" >
                        <div className="col-lg-6 col-md-6">
                            <div className="d-flex align-items-center">
                            <div className="filter_search_right">
                                    <div className="search_cat_top border-0">
                                        <div className="form-group pb-0 sort_by_box">
                                            <p className="sort_b_h text-right" onClick={handleSortByAction}><b className="mr-2"><FormattedMessage id="Select Actions"  />:</b>{actionname} <span className="icon-chevron_down"></span></p>
                                            <div className="sort_by_action">
                                                <ul>
                                                    {
                                                        selectActionJson && selectActionJson.map((data, key) => {
                                                            return (
                                                                <li className="activess" onClick={(e) => handleSelectAction(e, data.value)}>{data.display_name}</li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="filter_search_right ml-3">
                                    <div className="cus_switch d-flex align-item-center">
                                        <p className={`font-14 fm pr-3 ${!selectFancy ? "black-3B" : "gray-75"}`}>
                                            <FormattedMessage id="addsingleproduct.White" defaultMessage="White" />
                                        </p>
                                        <label className="switch">
                                            <input
                                                type="checkbox"
                                                checked={selectFancy}
                                                onChange={handleSelectFancy}
                                            />
                                            <span className="slider round"></span>
                                        </label>
                                        <p className={`font-14 fm pl-3 ${selectFancy ? "black-3B" : "gray-75"}`}>
                                            <FormattedMessage id="addsingleproduct.Fancy" defaultMessage="Fancy" />
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className=" col-lg-4 col-md-4 col-sm-4">
                            <div className="seach_filter position-relative">
                                <input type="text" value={search} onKeyPress={(e) => handleSearchFilter(e)} onChange={handleSearch} className="form-control" placeholder={useIntl().formatMessage({id: 'SearchByStock'})} />
                                <span className="icon-search_1  input_icon position-absolute" onClick={handleSearchIconClick} style={{cursor:'pointer'}}></span>
                            </div>
                        </div>
                    </div>

                    <div className="tbles mb-5">
                        <table width="100%">
                            <tr>
                                <th>
                                    <div className="form-group mb-0 mini checks inss">
                                        <input className="" type="checkbox" id="checkall" checked={checkHead} onChange={() => selectAll(selectAllStock)} />
                                        <label htmlFor="checkall"></label>
                                    </div>
                                </th>
                                <th><FormattedMessage id="addsingleproduct.stockno"/></th>
                                <th><FormattedMessage id="Shape" defaultMessage="Shape"/></th>
                                <th><FormattedMessage id="addsingleproduct.aveCT" defaultMessage="Ave./CT" /></th>
                                <th><FormattedMessage id="Pieces" defaultMessage="Pieces" /></th>
                                <th><FormattedMessage id="Total/CT" defaultMessage="Total/CT" /></th>
                                {isFancyList ? (
                                    <>
                                        <th><FormattedMessage id="Intensity" defaultMessage="Intensity" /></th>
                                        <th><FormattedMessage id="Overtone" defaultMessage="Overtone" /></th>
                                    </>
                                ) : null}
                                <th>
                                    {isFancyList ? (
                                        <FormattedMessage id="addsingleproduct.finishcolor" defaultMessage="Fancy Color" />
                                    ) : (
                                        <FormattedMessage id="addsingleproduct.color" />
                                    )}
                                </th>
                                <th><FormattedMessage id="addsingleproduct.clarity"/></th>
                                <th><FormattedMessage id="MM" defaultMessage="Millimeter" /></th>
                                <th><FormattedMessage id="Parcel" defaultMessage="Parcel" /></th>
                                <th><FormattedMessage id="Sieve" defaultMessage="Sieve"/></th>
                                <th><FormattedMessage id="Measurements" defaultMessage="Measurements"/></th>
                                <th><FormattedMessage id="addsingleproduct.price-ct" defaultMessage="Price/ct"/></th>
                                <th><FormattedMessage id="addsingleproduct.price_total_d" defaultMessage="$Total" /></th>
                                <th className="text-center"><FormattedMessage id="Status"/></th>
                            </tr>

                            {
                                myproduct && myproduct.products && myproduct.products.data.length > 0 ?
                                    myproduct && myproduct?.products && myproduct?.products?.data && myproduct.products.data.map((data, key) => {
                                        return (
                                            <tr>
                                                <td>
                                                    <div className="form-group mb-0 mini inss">
                                                        <input type="checkbox" id={data.id} name="check" checked={selectAllStock[key]} onChange={() => handleStockManagement(data.id, key)} />
                                                        <label htmlFor={data.id}></label>
                                                    </div>
                                                </td>
                                                <td onClick={() => handleDetails(data.id)}>{data && data.stock_number}</td>
                                                <td onClick={() => handleDetails(data.id)}>{pColmDisplay(data, 'a_shape')}</td>
                                                <td onClick={() => handleDetails(data.id)}>{data?.carat != null ? parseFloat(data.carat).toFixed(2) : ''}</td>
                                                <td onClick={() => handleDetails(data.id)}>{data?.pieces ?? ''}</td>
                                                <td onClick={() => handleDetails(data.id)}>{renderParcelTotalCt(data)}</td>
                                                {isFancyList ? (
                                                    <>
                                                        <td onClick={() => handleDetails(data.id)}>{pColmDisplay(data, 'a_fancy_intensity')}</td>
                                                        <td onClick={() => handleDetails(data.id)}>{pColmDisplay(data, 'a_fancy_overtone')}</td>
                                                        <td onClick={() => handleDetails(data.id)}>{pColmDisplay(data, 'a_fancy_color')}</td>
                                                    </>
                                                ) : (
                                                    <td onClick={() => handleDetails(data.id)}>{pColmDisplay(data, 'a_color')}</td>
                                                )}
                                                <td onClick={() => handleDetails(data.id)}>{pColmDisplay(data, 'a_clarity')}</td>
                                                <td onClick={() => handleDetails(data.id)}>{formatMmRangeValues(data?.mm)}</td>
                                                <td onClick={() => handleDetails(data.id)}>{data?.parcel ?? ''}</td>
                                                <td onClick={() => handleDetails(data.id)}>{pColmDisplay(data, 'a_sieve')}</td>
                                                <td onClick={() => handleDetails(data.id)}>{renderParcelMeasurements(data)}</td>
                                                <td onClick={() => handleDetails(data.id)}>
                                                    {data?.price != null ? `$${numberWithCommas(parseFloat(data.price).toFixed(2))}` : ''}
                                                </td>
                                                <td onClick={() => handleDetails(data.id)}>
                                                    {data?.price != null ? `$${renderParcelTotalPrice(data)}` : ''}
                                                </td>
                                                <td className="text-center" style={{ position: 'relative' }}>
                                                <span style={{color: data.status === 1 ? 'green':'red', fontWeight:'600'}}>{data.status === 1 ? <FormattedMessage id="Listed"/> : <FormattedMessage id="Unlisted"/>}</span>
                                                <div className="more">
                                                        <span><img src={IMAGES.THREE_DOT} /></span>
                                                        <ul>
                                                            {
                                                                data.status === 1 ?
                                                                    <li onClick={(e) => handleSingleActivate('deactivate', data.id)}><h6><FormattedMessage id="Unlist Item"  /></h6></li>
                                                                    :
                                                                    <li onClick={(e) => handleSingleActivate('active', data.id)}><h6><FormattedMessage id="List Item"  /></h6></li>
                                                                // <img src={IMAGES.EDIT_PNG} className="mr-2" alt="" />
                                                            }
                                                            <li>
                                                                <Link
                                                                    to={{ pathname: `${url}/edit-full-product/${category_slug}/${data.id}` }}
                                                                    className="not_a"
                                                                >
                                                                    <h6>
                                                                        <FormattedMessage id="addsingleproduct.editproduct" defaultMessage="Edit product" />
                                                                    </h6>
                                                                </Link>
                                                            </li>
                                                            <li onClick={(e) => handleSingleActivate('delete', data.id)}><h6><FormattedMessage id="Delete" /></h6></li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                    :
                                    <tr>
                                        <th colSpan={parcelTableColSpan}><FormattedMessage id="ProductNotFound" defaultMessage="Product not Found"/></th>
                                    </tr>
                            }

                        </table>
                    </div>
                    <div className="table_pagination">
                        <ReactPaginate
                            previousLabel={<i className="icon icon-chevron_gray-left"></i>}
                            nextLabel={<i className="icon icon-chevron_black"></i>}
                            pageCount={pageCount}
                            onPageChange={handlePageChange}
                            containerClassName={"paginationBttns"}
                            previousLinkClassName={"previousBttn"}
                            nextLinkClassName={"nextBttn"}
                            disabledClassName={"paginationDisabled"}
                            activeClassName={"paginationActive"}
                            forcePage={props?.pageReset}
                        />
                    </div>
                </div>
            </Fragment>
            {
                <PopupConfirm 
                message={useIntl().formatMessage({id: 'deleteAllProducts'})}
                title={useIntl().formatMessage({id: 'Confirmation'})}
                handleResForm={handleResForm} 
            />
            }
        </Fragment>
    )
}

export default Parcels
